import * as constants from './global-errors-display-constants';

export const clearStore = () => ({
  type: constants.CLEAR_STORE,
});

// payload is an object, and it has to include errorMessage in it
export const triggerError = payload => ({
  type: constants.ERROR_TRIGGERED,
  payload,
});

export const requestAccessFromAdmin = (payload) => dispatch => {
  dispatch({ type: constants.REQUEST_ACCESS_STARTED });
  return fetch('/proxy/userManagement/requestAccess', {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.REQUEST_ACCESS_FAILED, payload: response.error });
    return dispatch({ type: constants.REQUESTED_ACCESS });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.REQUEST_ACCESS_FAILED });
  });
};




// WEBPACK FOOTER //
// ./src/app/stores/global-errors-display/global-errors-display-actions.js